<div class="alert alert-info text-center">
	Please edit the cells indicating the number of rescheduled leads that this
	campaign should have during the selected weeks.
</div>

<div style="margin-top: 15px">
	<h4>Fill the available cells with the rescheduled leads:</h4>
</div>

<div #sheet></div>
